import DisregardedEntities from './DisregardedEntities';
export default DisregardedEntities;
